import { Component, Input, OnInit } from '@angular/core';
import { FilterDataService } from '../filter-data.service';

@Component({
  standalone: false,
  selector: 'app-filter-number-range',
  templateUrl: './filter-number-range.component.html',
  styleUrls: ['./filter-number-range.component.scss']
})
export class FilterItemNumberRangeComponent implements OnInit {
  @Input() filterName: string;

  range: { min: number | null; max: number | null } = { min: null, max: null };

  constructor(public dataService: FilterDataService) { }

  ngOnInit() {
    const existing = this.dataService.curFilter()[0];
    if (existing) {
      this.range = { min: existing.min ?? null, max: existing.max ?? null };
    }
  }

  onChange() {
    this.dataService.curFilter()[0] = { min: this.range.min, max: this.range.max };
  }
}
